import { render, staticRenderFns } from "./Manifest.vue?vue&type=template&id=454af378"
import script from "./Manifest.vue?vue&type=script&lang=js"
export * from "./Manifest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports